import { Component, computed, inject, input, OnInit, output } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
import { catchError, EMPTY, first } from 'rxjs';
import { ChatService } from '../../chat.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-chat-bubble',
  standalone: false,
  templateUrl: './chat-bubble.component.html',
  styleUrl: './chat-bubble.component.scss'
})
export class ChatBubbleComponent implements OnInit {
  message = input<any>(null);
  
  quote = input<boolean>(false);
  
  uploadedPhotos = output<any>();


  userService = inject(UserService);
  
  chatService = inject(ChatService);
  
  router = inject(Router);
  
  snackBar = inject(MatSnackBar);


  user:any
  
  constructor() {
    this.userService.user$.subscribe((user) => {
      this.user = user;
    });
  }
  ngOnInit(): void {
    
  }
  addPhotos(photos) {
    this.uploadedPhotos.emit(photos);
  }
  isToday(dateString: string): boolean {
    const date = new Date(dateString);
    const today = new Date();
    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
  }
  hasAttachments(message) {
    let value = false;
    if (message.pictures && message.pictures.length > 0) {
      value = true;
    }
    if(message.calendar_event){
      value = true;
    }
    if(message.reply){
      value = true;
    }
    return value;
  }
  setClasses(message) {
    const classes = {
      'quote': this.quote(),
      'own': message.isOwn,
      'system': message.isSystem,
      'kogu': message.isKogu,
      'event': message.calendar_event,
      'document': message.document,
    }
    return classes;
  }
  openWork(id){
    this.router.navigate(['main','work', id]);
  }


  goToDocumentChat(documentId: number) {
    this.chatService.addChat("Budget", documentId).pipe(
      first(),
      catchError(() => {
        this.snackBar.open(
          'Error al redireccinar al chat',
          'Cerrar',
          { duration: 3000, panelClass: 'snackbar-error' }
        );
        return EMPTY;
      }),
    ).subscribe();
  }
}
